import { render, staticRenderFns } from "./StatsWelcomeModal.vue?vue&type=template&id=7346d278&"
import script from "./StatsWelcomeModal.vue?vue&type=script&lang=js&"
export * from "./StatsWelcomeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports